module.exports = __webpack_public_path__ + "static/measures-c747320c695d38e8400c2769cccb4112.png";